import { Fragment, SetStateAction, Dispatch } from 'react'
import { Dialog, Transition } from '@headlessui/react'

// Icons
import CrossIcon from 'assets/icons/CrossIcon'

interface ModalContainerProps {
  isShown: boolean
  setModalFunction: Dispatch<SetStateAction<boolean>>
  children: JSX.Element | JSX.Element[]
  title?: string | JSX.Element
  className?: string
  noCloseButton?: boolean
}

const ModalContainer = ({
  isShown,
  setModalFunction,
  children,
  title = '',
  className = '',
  noCloseButton = false
}: ModalContainerProps) => (
  <Transition show={isShown}>
    <Dialog onClose={setModalFunction} className='relative !min-w-[100vw] z-99'>
      <Transition.Child
        enter='transition duration-100 ease-out'
        enterFrom='transform scale-95 opacity-0'
        enterTo='transform scale-100 opacity-100'
        leave='transition duration-75 ease-out'
        leaveFrom='transform scale-100 opacity-100'
        leaveTo='transform scale-95 opacity-0'
        as={Fragment}
      >
        <div
          className='fixed left-0 max-w-[100vw] top-0 w-[100vw] h-full bg-black/30'
          aria-hidden='true'
        />
      </Transition.Child>
      <div className='fixed top-0 max-w-[100vw] left-0 w-[100vw] h-full flex items-center justify-center p-4'>
        <Transition.Child
          as={Fragment}
          enter='ease-out duration-300'
          enterFrom='opacity-0 scale-95'
          enterTo='opacity-100 scale-100'
          leave='ease-in duration-200'
          leaveFrom='opacity-100 scale-100'
          leaveTo='opacity-0 scale-95'
        >
          <Dialog.Panel
            data-testid='container'
            className={`max-w-sm text-black border-gray-500 rounded-lg
          shadow-b bg-white md:ml-16 w-full p-5 md:p-6 ${className}`}
          >
            <div className='relative flex items-start justify-center'>
              {!!title && (
                <h3 className='text-black max-w-72 md:max-w-80 text-base font-bold text-center mx-8'>
                  {title}
                </h3>
              )}
              {!noCloseButton && (
                <button
                  className='hover:bg-gray-100 transition-all duration-200 absolute right-0 top-0 rounded-full w-8 h-8 flex justify-center items-center'
                  type='button'
                  onClick={() => setModalFunction(false)}
                >
                  <span className='sr-only'>Cerrar</span>
                  <CrossIcon stroke='#575372' />
                </button>
              )}
            </div>
            {!!title && <hr className='bg-gray-500 my-4' />}
            {children}
          </Dialog.Panel>
        </Transition.Child>
      </div>
    </Dialog>
  </Transition>
)

export default ModalContainer
